"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.composeTaggingEventPayload = composeTaggingEventPayload;
var _services = require("../services");
var _excluded = ["taggingId", "taggingType"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function composeTaggingEventPayload(_ref) {
  var pageName = _ref.pageName,
    eventLabel = _ref.eventLabel,
    currentPageName = _ref.currentPageName,
    stepIndex = _ref.stepIndex,
    eventName = _ref.eventName;
  if (!_services.analytics.IS_TAGGING_ENABLED) return null;
  var taggingEvents = _services.analytics.composeTaggingEvents({
    pageName: pageName,
    eventLabel: eventLabel,
    currentPageName: currentPageName,
    stepIndex: stepIndex
  });
  var taggingEvent = taggingEvents[eventName];
  if (!taggingEvent) return null;
  var taggingId = taggingEvent.taggingId,
    taggingType = taggingEvent.taggingType,
    rest = _objectWithoutProperties(taggingEvent, _excluded);
  return {
    taggingId: taggingId,
    taggingType: taggingType,
    taggingValue: rest
  };
}